/**
 * SSO Source
 *
 * Narrower subtype of UserAuthType representing only the SSO sources
 * (i.e. excluding "password"). Used by OAuth flows in places where a value
 * MUST be an SSO provider — e.g. OAuth state, controller query params,
 * sso-source path segments.
 *
 * Mirrors the UserStatus / UserAuthType pattern (const values + Zod enum
 * + companion const object).
 */

import { z } from "zod";

export const SSO_SOURCE_VALUES = {
  GOOGLE: "google",
} as const;

export const SsoSourceSchema = z.enum(SSO_SOURCE_VALUES);

export type SsoSource = z.infer<typeof SsoSourceSchema>;

export const SsoSource = {
  ...SSO_SOURCE_VALUES,
} as const;
